import { useState } from 'react'
import reactLogo from './assets/react.svg'
import './App.css'

function App() {
  const [progress, setProgress] = useState('')

  const generateHTML = async (event: React.MouseEvent<HTMLButtonElement>) => {

    const sleep = (msec : number) => new Promise(resolve => setTimeout(resolve, msec));

    console.log(event.button);
    let progress = 'HTML Generation started';
    setProgress(progress);

    const ifr = document.createElement('iframe');
    ifr.setAttribute('visibility', 'hidden');
    ifr.style.display = "none";
    
    let html = document.documentElement.innerHTML;
    let blob = new Blob([html], { type: 'text/html' });
    ifr.src = URL.createObjectURL(blob);
    document.body.appendChild(ifr);

    let totalWait = 0;
    let completed = false;
    while(totalWait < 10000) {
      await sleep(100);
      totalWait += 100;
      if (ifr.contentWindow?.document.readyState === 'complete'){
        completed = true;
        const tgtBtn = ifr.contentWindow.document.querySelector('button');
        if (tgtBtn)
          tgtBtn.parentNode?.removeChild(tgtBtn);
        break;
      }
    }
    console.log(completed ? 'completed' : 'failed');
    console.log(ifr.contentDocument?.documentElement.innerHTML);
    document.body.removeChild(ifr);
  }
  
  return (
    <>
      <div>
        <a href="https://react.dev" target="_blank">
          <img src={reactLogo} className="logo react" alt="React logo" />
        </a>
      </div>
      <h2>React HTML Generate Test</h2>
      <div className="card">
        <button onClick={generateHTML}>
          Generate HTML
        </button>
        <p>
          {progress}
        </p>
      </div>
      <p className="read-the-docs">
        
      </p>
    </>
  )
}

export default App
